import Vue from 'vue'
import Router from 'vue-router'
const TheDashboard = () => import('@/components/TheDashboard')
const TheProduct = () => import('@/components/TheProduct')
const TheSearch = () => import('@/components/TheSearch')
const TheLevelManage = () => import('@/components/TheLevelManage')
const TheValueStandard = () => import('@/components/TheValueStandard')
const TheCertificate = () => import('@/components/TheCertificate')
const TheType = () => import('@/components/TheType')
const TheGradeAndUnit = () => import('@/components/TheGradeAndUnit')
const TheParts = () => import('@/components/TheParts')
const TheColor = () => import('@/components/TheColor')
const TheVariety = () => import('@/components/TheVariety')
const TheVarietyGroup = () => import('@/components/TheVarietyGroup')
const UserLogin = () => import('@/components/users/UserLogin')
const UserRegister = () => import('@/components/users/UserRegister')
const UserProfile = () => import('@/components/users/UserProfile')
const UserAll = () => import('@/components/users/UserAll')
const ProductCreate = () => import('@/components/products/ProductCreate')
const VarietyView = () => import('@/components/varietys/VarietyView')
const TheSystematics = () => import('@/components/TheSystematics')
const TheUnit = () => import('@/components/TheUnit')

// User Management
const Role = () => import('@/components/users_management/Role')
const Permission = () => import('@/components/users_management/Permission')
const Privilege = () => import('@/components/users_management/Privilege')

const CausesCategory = () => import('@/components/diseases/CausesCategory')
const Caused = () => import('@/components/diseases/Caused')
const Diseases = () => import('@/components/diseases/Diseases')
const DiseaseInFarm = () => import('@/components/diseases/DiseaseInFarm')
const ThePlace = () => import('@/components/ThePlace')
// soil
const SoilGroup = () => import('@/components/soils/SoilGroup')
const SoilSerie = () => import('@/components/soils/SoilSerie')
const SoilTexture = () => import('@/components/soils/SoilTexture')
const SoilHorizon = () => import('@/components/soils/SoilHorizon')
const SoilStructure = () => import('@/components/soils/SoilStructure')

const TheBenchmark = () => import('@/components/TheBenchmark')
const Counties = () => import('@/components/Counties')
const Factors = () => import('@/components/factors/Factors')
const Variables = () => import('@/components/factors/Variables')
const Statistics = () => import('@/components/factors/Statistics')
const Parameters = () => import('@/components/factors/Parameters')
// Worker
const Area = () => import('@/components/workers/Area')
const Record = () => import('@/components/workers/Record')
const Worker = () => import('@/components/workers/Worker')

// Propagation
const PropagationMethod = () => import('@/components/propagations/PropagationMethod')
const PropagationProduct = () => import('@/components/propagations/PropagationProduct')
// Productivity
const Productivity = () => import('@/components/productivitys/Productivity')
// Seasonality
const SeasonalityRecord = () => import('@/components/seasonalitys/SeasonalityRecord')
const Seasonality = () => import('@/components/seasonalitys/Seasonality')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/components/TheDashboard')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/components/NotFound')
    },
    {
      // Here's the new catch all route
      path: '*',
      redirect: { name: '404' }
    },
    {
      path: '/network-issue',
      name: 'network-issue',
      component: () => import('@/components/NetworkIssue')
    },
    // FarmerSpace
    {
      path: '/farmerspace/question',
      name: 'farmerspace-question',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Question')
    },
    {
      path: '/farmerspace/knowledge/:knowLedgeId/edit',
      name: 'farmerspace-knowledge-edit',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/KnowledgeCreate')
    },
    {
      path: '/farmerspace/knowledge',
      name: 'farmerspace-knowledge',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Knowledge')
    },
    {
      path: '/farmerspace/content',
      name: 'FarmerSpaceContent',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Content')
    },
    {
      path: '/farmerspace/content-type',
      name: 'FarmerSpaceContentType',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/ContentType')
    },
    {
      path: '/farmerspace/topic',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Topic')
    },
    {
      path: '/farmerspace/exam',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Exam')
    },
    {
      path: '/farmerspace/intern',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/farmerspace/Intern')
    },
    // Cropperz
    {
      path: '/cropperz/supplier',
      name: 'Supplier',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/cropperz/Supplier')
    },
    {
      path: '/cropperz/other',
      name: 'Other',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/cropperz/Other')
    },
    // Intranet-Portal
    {
      path: '/banners',
      name: 'banners',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/banners/Banner')
    },
    {
      path: '/banner-positions',
      name: 'banner-positions',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/banners/BannerPositions')
    },
    {
      path: '/pages',
      name: 'pages',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/pages/Page')
    },
    {
      path: '/site',
      name: 'site',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/sites/Site')
    },
    {
      path: '/glycemic-index-infarm',
      name: 'glycemic-index-infarm',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/glycemics/GlycemicIndexInfarm')
    },
    {
      path: '/glycemic-index',
      name: 'glycemic-index',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/glycemics/GlycemicIndex')
    },
    {
      path: '/geographical-indication',
      name: 'geographical-indication',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/geographical/Indication')
    },
    {
      path: '/product/:productid',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/products/ProductView'),
      children: [
        // when /user/:id is matched
        {
          path: '',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductDetail')
        },
        {
          path: 'Detail',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductDetail')
        },
        {
          path: 'Variety/:varietyId?',
          name: 'variety',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductVariety')
        },
        {
          path: 'Parts/:partsId?',
          name: 'parts',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductParts')
        },
        {
          path: 'Grade',
          name: 'grade',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductGrade')
        },
        {
          path: 'Seasonality',
          name: 'seasonality',
          component: () =>
            import(
              /* webpackChunkName: "catalog" */ '@/components/products/views/ProductSeasonality'
            )
        },
        {
          path: 'Factor',
          name: 'factor',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductFactor')
        },
        {
          path: 'Lifetime',
          name: 'lifetime',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductLifetime')
        },
        {
          path: 'Worker',
          name: 'worker',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductWorker')
        },
        {
          path: 'More',
          name: 'more',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductMore')
        },
        {
          path: 'Raw-Data',
          name: 'rawdata',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductRawData')
        },
        {
          path: 'Content',
          name: 'content',
          component: () =>
            import(/* webpackChunkName: "catalog" */ '@/components/products/views/ProductContent')
        },
        {
          path: 'Content/create',
          name: 'product-content-create',
          component: () =>
            import(
              /* webpackChunkName: "catalog" */ '@/components/products/views/ProductContentCreate'
            )
        },
        {
          path: 'Content/:idx/edit',
          name: 'product-content-edit',
          component: () =>
            import(
              /* webpackChunkName: "catalog" */ '@/components/products/views/ProductContentCreate'
            )
        }
      ]
    },
    {
      path: '/type-group',
      name: 'type-group',
      component: () => import('@/components/types/TypeGroup')
    },
    {
      path: '/unit',
      name: 'TheUnit',
      component: TheUnit
    },
    {
      path: '/dashboard',
      name: 'TheDashboard',
      component: TheDashboard
    },
    {
      path: '/product-in-place',
      name: 'product-in-place',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/products/ProductInPlace')
    },
    {
      path: '/product',
      name: 'TheProduct',
      component: TheProduct
    },
    {
      path: '/search',
      name: 'TheSearch',
      component: TheSearch
    },
    {
      path: '/product/create/:language',
      name: 'ProductCreate',
      component: ProductCreate
    },
    {
      path: '/level',
      name: 'TheLevelManage',
      component: TheLevelManage
    },
    {
      path: '/value-standard',
      name: 'TheValueStandard',
      component: TheValueStandard
    },
    {
      path: '/login',
      name: 'UserLogin',
      component: UserLogin
    },
    {
      path: '/users',
      name: 'UserAll',
      component: UserAll
    },
    {
      path: '/create-new-admin',
      name: 'UserRegister',
      component: UserRegister
    },
    {
      path: '/profile',
      name: 'UserProfile',
      component: UserProfile
    },
    {
      path: '/type',
      name: 'TheType',
      component: TheType
    },
    {
      path: '/color',
      name: 'TheColor',
      component: TheColor
    },
    {
      path: '/variety',
      name: 'TheVariety',
      component: TheVariety
    },
    {
      path: '/variety/:varietyid',
      name: 'VarietyView',
      component: VarietyView
    },
    {
      path: '/grade',
      name: 'the-grade',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/TheGrade')
    },
    {
      path: '/grade-group',
      name: 'grade-group',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/grade/GradeGroup')
    },
    {
      path: '/certificate',
      name: 'TheCertificate',
      component: TheCertificate
    },
    {
      path: '/parts',
      name: 'TheParts',
      component: TheParts
    },
    {
      path: '/parts-group',
      name: 'parts-group',
      component: () => import('@/components/parts/PartsGroup')
    },
    {
      path: '/weighing-sources',
      name: 'TheWeighingSources',
      component: () => import('@/components/TheWeighingSources')
    },
    {
      path: '/sources',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/wesources/Sources')
    },
    {
      path: '/sources/index',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/wesources/SourcesIndex')
    },
    {
      path: '/sources/refer',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/wesources/SourcesRefer')
    },
    {
      path: '/variety-group',
      name: 'TheVarietyGroup',
      component: TheVarietyGroup
    },
    {
      path: '/systematics',
      name: 'TheSystematics',
      component: TheSystematics
    },
    {
      path: '/role',
      name: 'Role',
      component: Role
    },
    {
      path: '/permission',
      name: 'Permission',
      component: Permission
    },
    {
      path: '/privilege',
      name: 'Privilege',
      component: Privilege
    },
    {
      path: '/disease-in-farm',
      name: 'DiseaseInFarm',
      component: DiseaseInFarm
    },
    {
      path: '/diseases',
      name: 'Diseases',
      component: Diseases
    },
    {
      path: '/caused',
      name: 'Caused',
      component: Caused
    },
    {
      path: '/places/thailand',
      name: 'ThePlace',
      component: ThePlace
    },
    {
      path: '/soil-layer-name',
      name: 'soil-layer-name',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/soils/SoilLayerName')
    },
    {
      path: '/soil-color',
      name: 'soil-color',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/soils/SoilColor')
    },
    {
      path: '/soil-places',
      name: 'SoilPlaces',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/soils/SoilPlaces')
    },
    {
      path: '/soil-in-farm',
      name: 'SoilInFarm',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/soils/SoilInFarm')
    },
    {
      path: '/soil-group',
      name: 'SoilGroup',
      component: SoilGroup
    },
    {
      path: '/soil-series-detail',
      name: 'soil-series-detail',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/soils/SoilSeriesDetail')
    },
    {
      path: '/soil-series',
      name: 'SoilSerie',
      component: SoilSerie
    },
    {
      path: '/soil-texture',
      name: 'SoilTexture',
      component: SoilTexture
    },
    {
      path: '/soil-horizon',
      name: 'SoilHorizon',
      component: SoilHorizon
    },
    {
      path: '/soil-structure',
      name: 'SoilStructure',
      component: SoilStructure
    },
    {
      path: '/benchmarking',
      name: 'TheBenchmark',
      component: TheBenchmark
    },
    {
      path: '/country',
      name: 'Counties',
      component: Counties
    },
    {
      path: '/factors/variables',
      name: 'Variables',
      component: Variables
    },
    {
      path: '/factors/statistics',
      name: 'Statistics',
      component: Statistics
    },
    {
      path: '/factors/parameters',
      name: 'Parameters',
      component: Parameters
    },
    {
      path: '/factors',
      name: 'Factors',
      component: Factors
    },
    {
      path: '/properties',
      name: 'Properties',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/properties/Properties')
    },
    {
      path: '/properties/type',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/properties/PropertiesType')
    },
    {
      path: '/properties/in-farm',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/properties/PropertiesInFarm')
    },
    {
      path: '/causes-category',
      name: 'CausesCategory',
      component: CausesCategory
    },
    {
      path: '/area',
      name: 'Area',
      component: Area
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/equipment/Equipment')
    },
    {
      path: '/workflow-group',
      name: 'WorkflowGroup',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/workflow/WorkflowGroup')
    },
    {
      path: '/workflow/record',
      name: 'WorkflowRecord',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/workflow/WorkflowRecord')
    },
    {
      path: '/workflow/record/:workflowRecordId',
      name: 'Workflow',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/workflow/Workflow')
    },
    {
      path: '/workflow',
      name: 'workflow-all',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/workflow/WorkflowAll')
    },
    {
      path: '/worker-record',
      name: 'Record',
      component: Record
    },
    {
      path: '/worker/:workerrecordid',
      name: 'Worker',
      component: Worker
    },
    {
      path: '/propagation/methods',
      name: 'PropagationMethod',
      component: PropagationMethod
    },
    {
      path: '/propagation/product',
      name: 'PropagationProduct',
      component: PropagationProduct
    },
    {
      path: '/lifetime/period',
      name: 'LifetimePeriod',
      component: () => import('@/components/lifetimes/Period')
    },
    {
      path: '/lifetime/record',
      component: () => import('@/components/lifetimes/LifetimeRecord')
    },
    {
      path: '/lifetime/record/:lifetimeRecordId',
      name: 'Lifetime',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/lifetimes/Lifetime')
    },
    {
      path: '/productivity',
      name: 'Productivity',
      component: Productivity
    },
    {
      path: '/seasonality/visualize',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/TheSeasonality')
    },
    {
      path: '/seasonality/visualize/:productid',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/seasonalitys/SeasonalityProduct')
    },
    {
      path: '/seasonality/record',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/seasonalitys/SeasonalityRecord')
    },
    {
      path: '/seasonality/record/:seasonalityrecordid',
      name: 'Seasonality',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/seasonalitys/Seasonality')
    },
    {
      path: '/phases',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/phases/Phases')
    },
    {
      path: '/unit/measure',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/unit/UnitMeasure')
    },
    {
      path: '/raw-data',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/rawdata/RawData')
    },
    {
      path: '/raw-data/type',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/rawdata/RawDataType')
    },
    {
      path: '/festivals',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/festivals/Festivals')
    },
    {
      path: '/festivals/places',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/festivals/FestivalPlaces')
    },
    {
      path: '/festivals/products',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/festivals/FestivalProducts')
    },
    {
      path: '/package-product/type',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/package_products/PackageProductType')
    },
    {
      path: '/package-product',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/package_products/PackageProduct')
    },
    {
      path: '/document/type',
      component: () =>
        import(/* webpackChunkName: "catalog" */ '@/components/documents/DocumentType')
    },
    {
      path: '/document',
      component: () => import(/* webpackChunkName: "catalog" */ '@/components/documents/Document')
    },
    {
      path: '/cooking/menu-type',
      component: () => import('@/components/cookings/CookingMenuType')
    },
    {
      path: '/cooking/method',
      component: () => import('@/components/cookings/CookingMethod')
    },
    {
      path: '/cooking/menu',
      component: () => import('@/components/cookings/CookingMenu')
    },
    {
      path: '/cooking/menu/:cookingMenuId',
      name: 'CookingMenuView',
      component: () => import('@/components/cookings/CookingMenuView')
    },
    {
      path: '/vehicle',
      component: () => import('@/components/logistics/vehicles/Vehicle')
    },
    {
      path: '/vehicle/type',
      component: () => import('@/components/logistics/vehicles/VehicleType')
    },
    {
      path: '/vehicle/condition/type',
      component: () => import('@/components/logistics/vehicles/VehicleConditionType')
    },
    {
      path: '/motor-fuel',
      component: () => import('@/components/logistics/motor_fuel/MotorFuelView')
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js